import React, { useState, useEffect } from 'react'
import FreeChipsHasBeenReceivedPopUp from './FreeChipsHasBeenReceivedPopUp'
import ReduceBigNumbers from './ReduceBigNumbers'
import ReactGA from 'react-ga4'

const FreeChipsBannerDaily =( props ) => {
  const[ freeChipsTimer, setFreeChipsTimer ] = useState( null )
  const[ freeChipsTimerValue, setFreeChipsTimerValue ] = useState( null )
  const[ requestForFreeChipsSent, setRequestForFreeChipsSent ] = useState( false )
  const[ showPopUp, setShowPopUp ] = useState( false )
  const getChips =( target ) => {
    if( props.socket.socket ){
      if( props.user && props.user._id ){
        setRequestForFreeChipsSent( true )
        props.socket.socket.emit('getChips', { target: target });
        ReactGA.event({
          category: 'FreeChipsDaily',
          action: 'Get Free Chips',
          label: target,
        })
      }else{
        // відкрити діалог логіна
        props.toggleAuth( true )
      }
    }
  };


  useEffect(()=>{
    const freeChipsAreAcquiredDaily = props.user.playerActivity.freeChipsAreAcquiredDaily
    if( requestForFreeChipsSent && freeChipsAreAcquiredDaily !== null ){
      const freeChipsUsedLastTimeDate = new Date( freeChipsAreAcquiredDaily )
      const today = new Date()
      const tomorrow = new Date( today )
      tomorrow.setDate( tomorrow.getDate() + 1 )
      tomorrow.setHours( 0, 0, 0, 0 )
      freeChipsUsedLastTimeDate.setHours( 0, 0, 0, 0 )
      const diff = today - freeChipsUsedLastTimeDate
      if( diff < 1000 * 60 * 60 * 24 ){
        setShowPopUp( true )
      }
    }
  },[ requestForFreeChipsSent, props.user.playerActivity.freeChipsAreAcquiredDaily ])


  useEffect(() => {
    const setBannerTimer = () => {
    const freeChipsAreAcquiredDaily = props.user.playerActivity.freeChipsAreAcquiredDaily
        
    if( freeChipsAreAcquiredDaily !== null ) {
      const freeChipsUsedLastTimeDate = new Date( freeChipsAreAcquiredDaily )
      const today = new Date()
      const tomorrow = new Date( today )
      tomorrow.setDate( tomorrow.getDate() + 1 )
      tomorrow.setHours( 0, 0, 0, 0 )
      freeChipsUsedLastTimeDate.setHours( 0, 0, 0, 0 )

      const diff = today - freeChipsUsedLastTimeDate

      const timerValue = tomorrow - today
      setFreeChipsTimerValue( timerValue )

      if( diff < 1000 * 60 * 60 * 24 ) {
        const timerValue = tomorrow - today
        setFreeChipsTimerValue( timerValue )

        if( !freeChipsTimer ) {
          const timer = setInterval(() => {
            setFreeChipsTimerValue(( prevValue ) => {
              if( prevValue >= 0 ) {
                return prevValue - 1000
              } else {
                clearInterval( timer )
                return null
              }
            });
          }, 1000 )
          setFreeChipsTimer( timer ) 
        }
      }
    }
    }
    
    
    
    setBannerTimer()

    return () => {
      if( freeChipsTimer ) {
        clearInterval( freeChipsTimer )
      }
    };
  }, [ props.user.playerActivity.freeChipsAreAcquiredDaily ])

  const renderTimer = () => {
    if (freeChipsTimerValue) {
      return new Date(freeChipsTimerValue).toISOString().slice( 11, 19 )
    }
    return null;
  };

  if( freeChipsTimer ) {
    return (
      <div className="freeChips500pending">
        { showPopUp ? <FreeChipsHasBeenReceivedPopUp amount='500'/> : null }
        <div className="freeChips500ImgDissabled" style={{ backgroundImage: "url(images/getChips/freeChips500.png)", }} alt="Free Chips" >
          <div className="freeChips500pending_timerWrapper" onClick={() => {
          }}>
            <div className="freeChips500pending_timer">
              <h4>{renderTimer()}</h4>
            </div>
          </div>
        </div>
        <div className="buyChips_infoWrapper">
          <div className="buyChips_infoWrapper_textWrapper">
            <h3>{ ReduceBigNumbers( props.amount )}</h3>
            <div className='buyChips_chips' >
              <p>chips</p>
            </div>
          </div>
          <button className='purple_button_dissabled'>FREE</button>
        </div>
      </div>
    );
  } else {
    return (
      <div className="freeChips500">
        <div className='freeChipsMarker freeChipsMarker_getChipsPosition'></div>
        <div className="freeChips500Img" style={{ backgroundImage: "url(images/getChips/freeChips500.png)", }} alt="Free Chips" onClick={() => getChips('free500')}></div>
        <div className="buyChips_infoWrapper">
          <div className="buyChips_infoWrapper_textWrapper">
            <h3>{ ReduceBigNumbers( props.amount )}</h3>
            <div className='buyChips_chips' >
              <p>chips</p>
            </div>
          </div>
          <button className='purple_button' onClick={() => getChips('free500')}>
            FREE
          </button>
        </div>
      </div>
    );
  }
};

export default FreeChipsBannerDaily;


